import { useTranslation } from 'react-i18next';

import { Chip, Typography } from '@mui/joy';

import { CampaignStatus } from '../../models/CampaignStatus.enum';

export const CampaignBadge = ({ status }: { status: CampaignStatus }) => {
  const { t } = useTranslation();
  switch (status) {
    case CampaignStatus.ended:
      return (
        <Chip className='h-2' color='danger' size='md' variant='outlined'>
          <Typography level='body-xs'>{t('campaigns.badge.ended')}</Typography>
        </Chip>
      );
    case CampaignStatus.neverStarted:
      return (
        <Chip className='h-2' color='warning' size='md'>
          <Typography level='body-xs'>{t('campaigns.badge.never_started')}</Typography>
        </Chip>
      );
    case CampaignStatus.ongoing:
      return (
        <Chip className='h-2' color='success' size='md'>
          <Typography level='body-xs'>{t('campaigns.badge.ongoing')}</Typography>
        </Chip>
      );
    default:
      return (
        <Chip className='h-2' color='neutral' size='md'>
          <Typography level='body-xs'>{t('campaigns.badge.unknown')}</Typography>
        </Chip>
      );
  }
};
